import { render, staticRenderFns } from "./gruppiStati.vue?vue&type=template&id=3285d351&"
import script from "./gruppiStati.vue.ts?vue&type=script&lang=ts&"
export * from "./gruppiStati.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports